(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["villa-seli"] && !Shopify.designMode) return;
  try {
    
(() => {
  function initialise(site) {
    if (site.dataset.vsReady) return;
    site.dataset.vsReady = 'true';
    const form = site.querySelector('.vs-form');
    site.addEventListener('click', event => {
      const link = event.target.closest('[data-vs-room], [data-vs-package]');
      if (!link) return;
      const room = link.getAttribute('data-vs-room');
      const experience = link.getAttribute('data-vs-package');
      const select = site.querySelector(room ? '[data-vs-room-select]' : '[data-vs-package-select]');
      if (select) {
        select.value = room || experience;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
    if (!form) return;
    const arrival = form.querySelector('[data-vs-arrival]');
    const departure = form.querySelector('[data-vs-departure]');
    if (!arrival || !departure) return;
    const dateString = date => [date.getFullYear(), String(date.getMonth() + 1).padStart(2, '0'), String(date.getDate()).padStart(2, '0')].join('-');
    const today = new Date();
    arrival.min = dateString(today);
    function checkDates() {
      const earliest = arrival.value ? new Date(arrival.value + 'T12:00:00') : new Date();
      earliest.setDate(earliest.getDate() + 1);
      departure.min = dateString(earliest);
      departure.setCustomValidity(departure.value && departure.value < departure.min ? departure.dataset.dateError : '');
    }
    arrival.addEventListener('change', checkDates);
    departure.addEventListener('change', checkDates);
    form.addEventListener('submit', event => {
      arrival.min = dateString(new Date());
      checkDates();
      if (!form.checkValidity()) {
        event.preventDefault();
        form.reportValidity();
      }
    });
    checkDates();
  }
  document.querySelectorAll('[data-vs-site]').forEach(initialise);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-vs-site]').forEach(initialise));
})();

  } catch(e) { console.error(e); }
})();
})();
